import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge10 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の法人税務における消費税の取り扱い' fontWeight={700} />
                <p>
                    ゴルフ会員権には預託形態と株式形態の２種類がありますが、これらを法人がゴルフ場から直接取得する場合には、消費税の課税対象にはなりません。
                    <br />
                    ゴルフ場が会員権を発行する場合、預託形態であれば預託金、株式形態であれば出資金扱いとなり、どちらも「資産の譲渡等の対価」に該当しないためです。
                    <br />
                    ただし、会員権業者からの入手については、どちらも消費税の課税対象となります。
                    <br />
                    それに対して、返還されない入会金や手数料、所有者変更にともなう名義書換料などは「役務の提供の対価」となるため課税対象、加えてプレー代やロッカー使用料、年会費などの利用料金も課税対象になります。
                    <br />
                    つまり、入会金やロッカー使用料など、ゴルフ場が提供するサービスの料金は課税対象になりますが、会員権は会員権業者からの取得は課税、ゴルフ場から直接の取得はサービス料ではなく出資金や預り金としての扱いのため非課税になります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の評価損を計上するケース（税務上）' fontWeight={700} />
                <p>
                    ゴルフ会員権の取引相場が下がった場合、会計上と税務上とでは取り扱いが異なります。
                    <br />
                    税務上、預託金携帯であれば単純に保証金としての扱いになるため、また株式形態であれば非上場有価証券として扱われるため、原則として評価損を計上することが出来ません。
                    <br />
                    ただし、例外として評価損の計上が可能な場合があります。
                </p>

                <Heading3 title='税務上の減損処理を行うケース' />
                <p>
                    税務上の減損処理を行うケースについて対象となるのは、株式形態の会員権（有価証券）に限定され、発行法人の資産状態が著しく悪化したため、その価額が著しく低下したことが要件となります。
                    <br />
                    なお、その判定の際の時価は、取引相場ではなく期末時点における発行会社の純資産額によって決まります。
                    <br />
                    具体的には、特別清算等の開始決定等の法的な事実があった場合、もしくは、期末における発行法人の一株（または一口）当たりの純資産価額が、取得時のおおむね５０％以上下落した場合は、その差額について評価損を計上出来るとしています。
                    <br />
                    つまり、ゴルフ会員権の発行会社の財政状態が著しく悪化し、法的手続きを開始した場合、もしくは取得時点よりも一株（または一口）あたりの評価額が半分ほどにまで減ってしまった場合に限り、税務上も減損処理を認めているのです。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='更生手続等の開始による貸倒処理等（税務上）' fontWeight={700} />
                <p>
                    更生手続等が開始された際の貸倒処理には、貸倒損失処理と貸倒引当金処理があります。それぞれ計上可能なケースについて解説します。
                </p>

                <Heading3 title='貸倒処理（貸倒損失・貸倒引当金）を行うケース' />
                <p>
                    貸倒処理を行うケースについて対象となるのは、預託金形態の会員権に限られます。
                    <br />
                    発行会社に以下の事実が生じた場合、預託金返還請求権の全部又は一部が顕在化（金銭債権に転換）したとみなされ、その顕在化した部分については、貸倒処理もしくは貸倒引当金の対象とすることが出来ます。
                    <br />
                    <br />
                    <u>＜貸倒引当金の対象＞</u>
                    <br />
                    発行会社の特別清算手続・破産手続（清算型の倒産手続）の開始決定があったこと。
                    <br />
                    <br />
                    <u>＜貸倒損失の計上＞</u>
                    <br />
                    発行会社の民事再生手続等の法的手続により、その預託金の一部が切捨てられた場合。
                </p>

                <Heading3 title='貸倒損失の計上が可能なケース' />
                <p>
                    貸倒損失が計上可能なケースは以下の4つの場合で、預託金の一部又は全額の切捨てが決定した場合にその切捨てられた金額を貸倒損失として計上出来ます。
                    <br />
                    <br />
                    1.発行会社及びゴルフ場への更生計画の認可決定がされた場合
                    <br />
                    2.発行会社及びゴルフ場への再生計画の認可決定がされた場合
                    <br />
                    3.発行会社及びゴルフ場への特別清算に係る協定の認可決定がされた場合
                    <br />
                    4.発行会社及びゴルフ場が破産手続の廃止・終結により消滅した場合
                    <br />
                    <br />
                    ただし、この場合において、所有する会員権の帳簿価額が預託金の額面金額を下回っている時は、貸倒損失として計上出来る金額は、切捨てられた金額から、預託金の額面金額と帳簿価額との差額を控除した金額となります。
                    <br />
                    なお、法的に預託金の返還金が切捨てられた金額は、その決定があった事業年度に限り損金となりますので注意が必要です。
                </p>

                <Heading3 title='貸倒引当金としての計上が可能なケース' />
                <p>
                    貸倒引当金が計上可能なケースについては慎重な判断が必要となります。
                    <br />
                    ポイントは、施設利用権（プレー権）がなくなって、預託金の返還請求権が発生しているかどうかです。
                    <br />
                    従って、民事再生法による再生手続等の再建型の倒産処理手続については、手続開始申立がされただけではプレー権が消滅していないので、貸倒引当金の計上は認められません。
                    <br />
                    結果として、貸倒引当金の計上は以下のようなケースに限られ、債権額から取り立て等の見込みがある金額を除いた残額の５０％を計上出来ます。
                    <br />
                    <br />
                    1.発行会社及びゴルフ場への破産手続開始の申立がされた場合
                    <br />
                    2.発行会社及びゴルフ場への特別清算開始の申立がされた場合
                    <br />
                    3.発行会社及びゴルフ場への更生手続開始、再生手続開始の申立がされた場合において、退会届を提出した場合
                    <br />
                    <br />
                    貸倒損失との違いは、更生手続等の申立がされた時点であり、まだ法的に切捨て額（損失）が決定されていないことです。
                    <br />
                    そのため、貸倒に備えて債権額の一部を貸倒引当金として処理しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='法律に基づき税務処理を' fontWeight={700} />
                <p>
                    ゴルフ会員権を発行している会社の経営状態が著しく悪化した場合は、減損処理（評価損）や貸倒損失・貸倒引当金の計上が可能な場合がありますが、評価損・貸倒損失の計上のタイミングや処理方法など、一般会計処理に比べると、とても煩雑になっています。
                    <br />
                    特に税務処理は、法令に基づき正しく行う必要がありますので、あまり得意でないと感じる場合は、まずは専門家に相談することが確実かつ安全と言えるでしょう。
                    <br />
                    そもそもどのような状況になったら評価損（減損）を検討すべきかという判定基準については
                    <a href='/knowledge/37'>ゴルフ会員権の減損・評価損の判定基準</a>
                    で整理していますので、あわせてご確認ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge10;
